













































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";

import MyForm from "@/mixins/form";

@Component
export default class extends Mixins(MyForm) {
  @Prop() video!: string;

  videoUrl: string = "";

  handleSubmit() {
    this.form.validateFields((err: any, fieldValues: any) => {
      if (!err) {
        this.showTsConfirm({
          title: "确认信息",
          content: "确定要提交吗？",
          onOk: async () => {
            const res = await this.$store.dispatch("agreement/audit", {
              record_id: this.editId,
              ...fieldValues,
            });
            if (res && res.Message && res.Message === "success") {
              this.$message.success("添加成功");
              this.handleCancel();
            } else {
              this.$message.error("添加失败");
            }
          },
        });
      }
    });
  }

  mounted() {
    this.getSecretVideo(this.video).then((res: any) => {
      // console.log(res);
      this.videoUrl = res;
    });
  }
}
